module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"colors":"Farben"},"en":{"colors":"Colors"}}')
  delete Component.options._Ctor
}
